import React from 'react';
import { Check, Star } from 'lucide-react';

const PackageCard = ({ pkg, index }) => {
  return (
    <div
      className={`glass rounded-2xl overflow-hidden card-hover ${
        pkg.popular ? 'ring-2 ring-[var(--gold)] relative' : ''
      }`}
      style={{ animationDelay: `${index * 100}ms` }}
    >
      {pkg.popular && (
        <div className="absolute top-4 right-4 z-10">
          <div className="bg-[var(--gold)] text-black px-3 py-1 rounded-full text-xs font-bold flex items-center space-x-1">
            <Star size={12} fill="currentColor" />
            <span>Popüler</span>
          </div>
        </div>
      )}

      <div className="p-6 md:p-8 space-y-6">
        {/* Header */}
        <div className="space-y-3">
          <h3 className="text-2xl md:text-3xl font-bold font-['Playfair_Display'] text-[var(--gold)]">
            {pkg.name}
          </h3>
        </div>

        {/* Description */}
        <p className="text-gray-400 text-sm leading-relaxed">{pkg.description}</p>

        {/* Features */}
        <ul className="space-y-3">
          {pkg.features.map((feature, i) => (
            <li key={i} className="flex items-start space-x-3">
              <Check size={20} className="text-[var(--gold)] mt-0.5 flex-shrink-0" />
              <span className="text-gray-300 text-sm">{feature}</span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default PackageCard;